/**
 * Converts a File object to base64 encoded string
 * @param {File} file - The image file to convert
 * @returns {Promise<string>} Promise that resolves with base64 string
 */
export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

/**
 * Extracts the base64 data part from a full base64 string
 * @param {string} base64String - The full base64 string (with prefix)
 * @returns {string} Just the base64 data part
 */
export const extractBase64Data = (base64String) => {
  return base64String.split(",")[1];
};
